<template>
  <main class="tryout-form">
    <section class="tryout-form__header">
      <h2 class="tryout-form__title">Tryout</h2>
    </section>

    <section class="tryout-form__body">
      <form class="tryout-form__body" @submit.prevent="saveTryout">
        <div class="tryout-form__group">
          <label for="team">Team</label>
          <input v-model="team" type="text" id="team" />
        </div>
        <div class="tryout-form__group">
          <div>
            Dates
            <app-button text type="button" @click="addDate">+</app-button>
          </div>
          <div class="tryout-form__dates">
            <div
              v-for="(date, index) in dates"
              :key="index"
              class="tryout-form__date"
            >
              <app-date-picker
                v-model="dates[index]"
                class="tryout-form__date-picker"
              />
              <app-button text type="button" @click="destroy(index)">
                <app-icon variant="delete" text />
              </app-button>
            </div>
          </div>
        </div>
        <div class="tryout-form__group">
          <label for="type">Type</label>
          <app-select id="type" v-model="type" :options="typeOptions" />
        </div>
        <div class="tryout-form__controls">
          <app-button text to="/">Cancel</app-button>
          <app-button color="accent" type="submit">{{
            $route.params.id ? 'Save' : 'Add'
          }}</app-button>
        </div>
      </form>
    </section>
  </main>
</template>

<script>
import AppButton from '@/components/AppButton.vue'
import AppDatePicker from '@/components/AppDatePicker.vue'
import AppIcon from '@/components/AppIcon.vue'
import AppSelect from '@/components/AppSelect.vue'

export default {
  components: {
    AppButton,
    AppDatePicker,
    AppIcon,
    AppSelect,
  },
  data() {
    return {
      dates: [],
      team: '',
      type: 'target',
      typeOptions: [
        { text: 'Stretch', value: 'stretch' },
        { text: 'Target', value: 'target' },
        { text: 'Safety', value: 'safety' },
      ],
    }
  },
  mounted() {
    if (this.$route.params.id) {
      const tryout = this.$store.getters['tryout/get'](this.$route.params.id)
      this.team = tryout.team
      this.type = tryout.type
      this.dates = tryout.dates
    }
  },
  methods: {
    addDate() {
      this.dates = [...this.dates, new Date().valueOf()]
    },
    destroy(index) {
      this.dates = [
        ...this.dates.slice(0, index),
        ...this.dates.slice(index + 1),
      ]
    },
    saveTryout() {
      this.$store.dispatch('tryout/addOrUpdate', {
        id: this.$route.params.id,
        team: this.team,
        dates: this.dates,
        type: this.type,
      })
      this.$router.push('/')
    },
  },
}
</script>

<style lang="scss" scoped>
.tryout-form {
  margin: auto;
  max-width: 512px;
  width: 90vw;

  &__controls {
    display: flex;
    gap: 1rem;
    justify-content: flex-end;
  }

  &__date {
    align-items: center;
    display: flex;
    gap: 1rem;
  }

  &__date-picker {
    flex: 1;
  }

  &__dates {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-top: 1rem;
  }

  &__group {
    display: flex;
    flex-direction: column;
    margin: 2rem 0;
  }

  &__header {
    padding: 1rem 0;
  }

  &__title {
    font-weight: 100;
    font-size: max(3vw, 2.5rem);
    padding: 1rem 0;
  }
}
</style>
